module.exports = __webpack_public_path__ + "img/m_a.338861d8.png";